import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { NgbDateAdapter, NgbDatepicker, NgbDateStruct, NgbPopover, NgbPopoverConfig, NgbTimeAdapter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { noop } from 'rxjs/internal/util/noop';
import { DateTimeModel } from './date-time-model';
import { NgbDateStructAdapter } from './ngb-date-struct-adapter';
import { NgbTimeStructAdapter } from './ngb-time-struct-adapter';
/**
 * na podstawie https://stackblitz.com/edit/angular-datetimepicker
 */
@Component({
  selector: 'enauka-datetimepicker',
  templateUrl: './datetimepicker.component.html',
  styleUrls: ['./datetimepicker.component.css'],
  providers: [
    //enauka-datetimepicker korzysta z domyslnych adapterow
    { provide: NgbDateAdapter, useClass: NgbDateStructAdapter },
    { provide: NgbTimeAdapter, useClass: NgbTimeStructAdapter }
  ]
})
export class DatetimepickerComponent implements ControlValueAccessor, OnInit, AfterViewInit {
  @Input()
  date: string;
  @Input()
  inputDatetimeFormat = "yyyy-MM-dd HH:mm";
  @Input()
  hourStep = 1;
  @Input()
  minuteStep = 15;
  @Input()
  secondStep = 30;
  @Input()
  seconds = false;
  @Input()
  disabled = false;
  @Output()
  dateSelected: EventEmitter<string> = new EventEmitter<string>();

  showTimePickerToggle = false;

  datetime: DateTimeModel = new DateTimeModel();
  private firstTimeAssign = true;

  @ViewChild(NgbPopover, { static: true })
  private popover: NgbPopover;

  private onTouched: () => void = noop;
  private onChange: (_: any) => void = noop;

  constructor(private config: NgbPopoverConfig) {
    config.autoClose = "outside";
    config.placement = "left";
  }

  ngOnInit(): void {
    setTimeout(() => {
      if (this.date)
        this.writeValue(this.date);
    })
  }

  ngAfterViewInit(): void {
    this.popover.hidden.subscribe($event => {
      this.showTimePickerToggle = false;
    });
  }

  writeValue(newModel: string) {
    if (newModel) {
      this.datetime = Object.assign(
        this.datetime,
        DateTimeModel.fromLocalString(newModel)
      );
      this.date = newModel;
      this.setDateStringModel();
    } else {
      this.datetime = new DateTimeModel();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  toggleDateTimeState($event) {
    this.showTimePickerToggle = !this.showTimePickerToggle;
    $event.stopPropagation();
  }

  setTodaysDate($event, dp: NgbDatepicker) {
    this.onDateChange(DateTimeModel.fromLocalString(new Date().toISOString()));
    dp.writeValue(this.datetime);
    this.showTimePickerToggle = !this.showTimePickerToggle;
    $event.stopPropagation();
  }

  setCurrentTime($event, tp) {
    this.onTimeChange(DateTimeModel.fromLocalString(new Date().toISOString()));
    tp.writeValue(this.datetime);
    $event.stopPropagation();
  }

  closePopover($event) {
    this.popover.close();
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange($event: any) {
    const value = $event.target.value;
    const dt = DateTimeModel.fromLocalString(value);

    if (dt) {
      this.datetime = dt;
      this.setDateStringModel();
    } else if (value.trim() === "") {
      this.datetime = new DateTimeModel();
      this.date = "";
      this.onChange(this.date);
    } else {
      this.onChange(value);
    }
  }

  onDateChange($event: string | NgbDateStruct) {
    const date = new DateTimeModel($event);

    if (!date) {
      this.date = this.date;
      return;
    }

    if (!this.datetime) {
      this.datetime = date;
    }

    this.datetime.year = date.year;
    this.datetime.month = date.month;
    this.datetime.day = date.day;

    const adjustedDate = new Date(this.datetime.toString());
    if (this.datetime.timeZoneOffset !== adjustedDate.getTimezoneOffset()) {
      this.datetime.timeZoneOffset = adjustedDate.getTimezoneOffset();
    }

    this.setDateStringModel();
  }

  onTimeChange(event: NgbTimeStruct) {
    this.datetime.hour = event.hour;
    this.datetime.minute = event.minute;
    this.datetime.second = event.second;

    this.setDateStringModel();
  }

  setDateStringModel() {
    this.date = this.datetime.toString();
    this.dateSelected.next(this.date);
    if (!this.firstTimeAssign) {
      this.onChange(this.date);
    } else {
      // Skip very first assignment to null done by Angular
      if (this.date !== null) {
        this.firstTimeAssign = false;
      }
    }
  }

  inputBlur($event) {
    this.onTouched();
  }

}
